import { render } from "./WCSearchBar.vue?vue&type=template&id=40feb119&scoped=true"
import script from "./WCSearchBar.vue?vue&type=script&lang=js"
export * from "./WCSearchBar.vue?vue&type=script&lang=js"

import "./WCSearchBar.vue?vue&type=style&index=0&id=40feb119&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40feb119"]])

export default __exports__